module.exports = __webpack_public_path__ + "img/91.ba6add80.png";